import { api } from "@/lib/http";
import type { Staging, StagingSummary } from "@/types/api";

// The Stagings page pages server-side, so its search box and status quick
// filters travel with the request for the same reason the home panel's do.
export interface ListParams {
  skip?: number;
  limit?: number;
  sort?: string;
  search?: string;
  statuses?: number[];
}

export interface StagingListResponse {
  items: Staging[];
  total: number;
}

// The home Properties panel pages server-side, so its search box and status
// quick filters have to travel with the request — filtering the page that came
// back would only ever narrow the page the user happens to be on.
export interface SummaryParams {
  skip?: number;
  limit?: number;
  search?: string;
  statuses?: number[];
}

export const stagingsApi = {
  list: ({ statuses, ...rest }: ListParams = {}) =>
    api.get<StagingListResponse>("/api/stagings", {
      ...rest,
      statuses: statuses?.length ? statuses.join(",") : undefined,
    }),
  summary: ({ statuses, ...rest }: SummaryParams = {}) =>
    api.get<StagingSummary[]>("/api/stagings/summary", {
      ...rest,
      statuses: statuses?.length ? statuses.join(",") : undefined,
    }),
  get: (id: number) => api.get<Staging>(`/api/stagings/${id}`),
  create: (body: Partial<Staging>) => api.post<Staging>("/api/stagings", body),
  update: (id: number, body: Partial<Staging>) => api.put<Staging>(`/api/stagings/${id}`, body),
  patchStatus: (id: number, status: number) =>
    api.patch<Staging>(`/api/stagings/${id}/status`, { status }),
  remove: (id: number) => api.del<void>(`/api/stagings/${id}`),
  moveItemsToStorage: (id: number) => api.post<void>(`/api/stagings/${id}/moveItemsToStorage`),
};
